<template>
  <el-dialog
    :title="editForm.id==null||editForm==''?'登记Sim卡':'编辑Sim卡'"
    :visible="editFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="editForm.id!=null&&editForm!=''"
    :modal-append-to-body='false'
    :before-close="clearEditForm" >
    <el-form :model="editForm" ref="editForm" size="mini" class="edit_form" :rules="editFormRules">
      <el-col :span="12">
        <el-form-item label="运营商" :label-width="formLabelWidth" prop="operatorId">
 <!--         <el-select placeholder="运营商" v-model="editForm.operatorId" @change="operatorSelect">
            <el-option v-for="item in operatorForSelect" :key="item.id"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini" ref="cascader"
                        placeholder="运营商"  filterable
                        :options="this.setTreeDisable(this.operatorForSelect)"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        :show-all-levels="false"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="editForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属场站" :label-width="formLabelWidth" prop="stationId">
          <el-select placeholder="选择站" v-model="editForm.stationId" @change="stationSelect">
            <el-option v-for="item in stationsForSelect" :key="item.id"
                       v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="所属设备" :label-width="formLabelWidth" prop="pileId">
          <el-select placeholder="选择桩" v-model="editForm.pileId">
            <el-option v-for="item in pilesForSelect" :key="item.id"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
	  <el-col :span="12">
	    <el-form-item label="营业商" :label-width="formLabelWidth" prop="businessId">
	      <el-select placeholder="营业商" v-model="editForm.businessId">
	        <el-option v-for="item in businessListTree" :key="item.id"
	                   v-bind:label="item.businessName" v-bind:value="item.id"></el-option>
	      </el-select>
	    </el-form-item>
	  </el-col>
      <el-col :span="12">
        <el-form-item label="套餐" :label-width="formLabelWidth" prop="packageType">
          <el-input placeholder="请输入套餐" v-model="editForm.packageType" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="流量(Mb)" :label-width="formLabelWidth" prop="flow">
          <el-input placeholder="请输入流量(Mb)" v-model="editForm.flow" clearable></el-input>
        </el-form-item>
      </el-col>
      <!--          <el-col :span="12">-->
      <!--            <el-form-item label="通话时长" :label-width="formLabelWidth" prop="callDuration">-->
      <!--              <el-input placeholder="请输入通话时长" v-model="editForm.callDuration" clearable></el-input>-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <!--          <el-col :span="12">-->
      <!--            <el-form-item label="短信条数" :label-width="formLabelWidth" prop="smsCount">-->
      <!--              <el-input placeholder="请输短信条数" v-model="editForm.smsCount"></el-input>-->
      <!--            </el-form-item>-->
      <!--          </el-col>-->
      <el-col :span="12">
        <el-form-item label="卡号" :label-width="formLabelWidth" prop="cardNo">
          <el-input placeholder="请输入卡号" v-model="editForm.cardNo"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="付费类型：" :label-width="formLabelWidth" prop="payType">
          <el-select placeholder="请选择付费类型" v-model="editForm.payType">
            <el-option v-for="item in payTypeData" :key="item.value"
                       v-bind:label="item.message" v-bind:value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="有效期" :label-width="formLabelWidth" prop="validityPeriod">
          <el-date-picker v-model="editForm.validityPeriod" type="date" value-format="yyyy-MM-dd" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通知号码" :label-width="formLabelWidth" prop="phone">
          <el-input v-model="editForm.phone" placeholder="临近有效期通知的手机号码"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="通知邮箱" :label-width="formLabelWidth" prop="email">
          <el-input v-model="editForm.email" placeholder="临近有效期通知的邮箱"></el-input>
        </el-form-item>
      </el-col>
      <!--隐藏id-->
      <el-col :span="12" hidden>
        <el-form-item hidden label="id" :label-width="formLabelWidth" prop="id">
          <el-input v-model="editForm.id" autocomplete="off"></el-input>
        </el-form-item>
      </el-col>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="clearEditForm">取 消</el-button>
      <el-button size="small" type="primary" @click.native="editSubmit" :loading="editSubmitLoading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {isInteger,validatePhone,validateInput,validateEMail,simCardLength} from '../../../../common/validator'
  export default {
    name: "add",
    data(){
      return{
        editFormRules: {
          operatorId: [{required: true, message: '请选择所属运营商', trigger: 'blur'}],
          stationId: [{required: true, message: '请选择所属站', trigger: 'blur'}],
          pileId: [{required: true, message: '请选择所属桩', trigger: 'blur'}],
          businessId: [{required: true, message: '请选择营业商', trigger: 'blur'}],
          packageType: [{required: true, message: '请输入套餐类型', trigger: 'blur'},
            {validator: function (rule, value, callback) {
              if (value == '' || value ==null || value == 'undefined'){
                callback();
                return
              }
              if (value.length>10){
                callback(new Error('长度不能大于10'));
              }
              let reg=/[`~!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、 ]/
              if (reg.test(value)){
                callback(new Error('不能输入"/"以外的字符'));
              }
              callback();
              }, trigger: 'blur'}
            ],
          flow: [{required: true, message: '请输入流量', trigger: 'blur'},{validator: function (rule, value, callback) {
              if (value == '' || value ==null || value == 'undefined'){
                callback();
                return
              }
              let reg=/[`~!@#$%^&*()_\-+=<>?:"{}|,.;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、 ]/
              if (value.length>10){
                callback(new Error('长度不能大于10'));
              }
              if (reg.test(value)){
                callback(new Error('不能输入"/"以外的字符'));
              }
              callback();
            }, trigger: 'blur'}
            ],
          cardNo: [{required: true, message: '请输入Sim卡号码', trigger: 'blur'},
            {validator:function (rule, value, callback) {
                validateInput(rule, value, callback,13,20,true,true,true,false,false,false,false)
              },trigger: 'blur'},
            {validator:simCardLength,trigger:'blur'}
            ],
          validityPeriod: [{required: true, message: '请选择有效期', trigger: 'blur'}],
          payType: [{required: true, message: '请输入付费类型', trigger: 'blur'}],
          phone: [{required: true, message: '请输入到期前通知手机号码', trigger: 'blur'},{validator:validatePhone,trigger: 'blur'}],
          //email: [{required: true, message: '请输入到期前通知邮箱', trigger: 'blur'},{validator:validateEMail,trigger: 'blur'}]
        },
        formLabelWidth: '100px',
      }
    },
    props:{
      editForm:{},
      editFormVisible:false,
	    businessListTree:{},
      operatorForSelect:{},
      stationsForSelect:{},
      pilesForSelect:{},
      operatorTypeData:"",
      payTypeData:"",
      editSubmitLoading:false,
    },
    methods:{
      clearEditForm(){
        let _this = this
        if(this.editForm.id == null || this.editForm == '') {
          this.$confirm('是否要取消当前操作？').then(_ => {
            _this.$refs.editForm.clearValidate()
            _this.$emit('closeEditForm')
          }).catch(_ => {})
        }else {
          _this.$refs.editForm.clearValidate()
          _this.$emit('closeEditForm')
        }
      },
      editSubmit(){
        this.$emit("editSubmit", this.$refs.editForm)
      },
      //对数据进行授权过滤
      setTreeDisable(val) {
        //对 treeList 进行递归操作，禁止选中unchecked和unapproved
        val && val.forEach(item => {
          if ((item.checked && (item.checked === 'unchecked' || item.checked === 'unapproved'))) {
            item.disabled = true; // 如果类型为unchecked或者unapproved，就增加禁用选项
          }
          if (item.children) {
            this.setTreeDisable(item.children);
          }
        });
        return val;
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.editForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      operatorSelect(val){
        this.$emit("operatorSelect", val)
      },
      stationSelect(val){
        this.$emit("stationSelect", val)
      },
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .edit_form {
    .el-form-item__content {
      .el-input {
        width: 220px;
      }
    }
  }

  .timeLabOut {
    margin-top: 20px;
    user-select: none;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    border-top: 1px solid rgba(0, 0, 0, 0.2);
  }

  .timeLabIn {
    user-select: none;
    width: 100%;
    line-height: 40px;
  }

  .timeLabInCol {
    user-select: none;
    border-right: 1px solid rgba(0, 0, 0, 0.2);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .topCheck {
    background-color: rgba(64, 158, 255, 0.6);
  }

  .summitCheck {
    background-color: rgba(103, 194, 58, 0.6);
  }

  .flatCheck {
    background-color: rgba(245, 108, 108, 0.6);
  }

  .valleyCheck {
    background-color: rgba(230, 162, 60, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/simCardManager/add.vue